import React from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";

import { PasswordInput } from "../";
import { Button } from "arv-reactcomponents";
import staticEndpoints from "../../../api/endPoints/staticEndpoints";

@inject("LoginStore")
@observer
class ResetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.passwordFieldNew = null;
    this.passwordFieldConfirm = null;
    this.onSubmit = this.onSubmit.bind(this);
  }
  componentDidMount() {
    const invalidInput = document.querySelector(".nw-resetpwd-form input");
    if (invalidInput) {
      setTimeout(() => {
        invalidInput.focus();
      });
    }
  }
  componentDidUpdate() {
    const invalidInput = document.querySelector(".nw-resetpwd-form input");
    invalidInput.focus();
  }
  onSubmit(e) {
    const sessionId = "2862ade0-80a4-4ce0-8e12-fec8551d31ac";
    e.preventDefault();
    const invalidInput = document.querySelector(
      ".nw-resetpwd-form input.is-invalid",
    );
    if (invalidInput) {
      invalidInput.focus();
      return;
    }
    let { password: newPassword } = this.passwordFieldNew.state;
    let { password: confirmPassword } = this.passwordFieldConfirm.state;
    newPassword = newPassword ? newPassword.trim() : "";
    confirmPassword = confirmPassword ? confirmPassword.trim() : "";
    if (
      this.passwordFieldNew.state.isPasswordInputValid &&
      this.passwordFieldConfirm.state.isPasswordInputValid &&
      newPassword === confirmPassword
    ) {
      if (sessionId)
        this.props.LoginStore.resetPasswordAction(sessionId, newPassword);
    } else {
      this.props.LoginStore.setAuthError(
        true,
        "Passwords don't match. Please enter same password.",
      );
    }
  }
  get checkIsFormValid() {
    return this.props.LoginStore.authError ? "" : "nwc-hidden";
  }
  get isShowLoader() {
    return this.props.LoginStore.loader ? "" : "nwc-hidden";
  }
  render() {
    return (
      <div className="nw-login-container">
        <div className="nw-login-heading">
          <h1 className="nw-login-title">RESET PASSWORD</h1>
        </div>
        <div className="nw-reset-img">
          <img
            className="nw-reset-password-image"
            src={staticEndpoints.resetImage}
            alt="reset password"
          />
        </div>
        <form className="nw-form nw-resetpwd-form" onSubmit={this.onSubmit}>
          <PasswordInput
            className="nw-login-input nw-resetpwd-password"
            placeholder="Enter New Password"
            name="newPassword"
            minLength={8}
            ref={values => {
              this.passwordFieldNew = values;
            }}
          />
          <PasswordInput
            className="nw-login-input nw-resetpwd-confirmpassword"
            placeholder="Confirm Password"
            name="confirmPassword"
            minLength={8}
            ref={values => {
              this.passwordFieldConfirm = values;
            }}
          />
          <Button
            type="submit"
            className="nwc-btn-primary nw-login-btn nw-resetpwd-submitbtn"
            onClick={this.onSubmit}
          >
            SUBMIT
            <div className={`nw-login-loader ${this.isShowLoader}`}>
              <img
                className="nw-loader"
                src="//static.nnnow.com/client/assets/images/icon/loader.gif"
                alt="loader"
              />
            </div>
          </Button>
          <span className={`nw-login-error ${this.checkIsFormValid}`}>
            {this.props.LoginStore.authErrorMsg}
          </span>
        </form>
      </div>
    );
  }
}
ResetPassword.wrappedComponent.propTypes = {
  LoginStore: PropTypes.shape({
    authError: PropTypes.bool.isRequired,
    authErrorMsg: PropTypes.string.isRequired,
    setAuthError: PropTypes.func.isRequired,
    resetPasswordAction: PropTypes.func,
    loader: PropTypes.bool.isRequired,
  }).isRequired,
};

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/component/Login/ResetPassword/index.js